import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 복지포인트 관리자페이지 - 작성된 전체 리스트 
 * @param {*} body 
 * @returns 
 */

const wpReceiveDocList =(body)=>{
    return customAxios.post(myIpAddress+'/wp/receiveDocList', body);
    
}
export default wpReceiveDocList;
